import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

import { featureFlags } from '../../app.settings';

@Injectable()
export class FeatureFlagGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const flag = route.data.featureFlag as string;
    if (featureFlags[flag]) {
      return true;
    }
    this.router.navigate(['/developers/api-keys']);
    return false;
  }
}
